import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0998688e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "floating-input relative" }
const _hoisted_2 = { class: "absolute top-1 right-0 flex items-center" }
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-7 h-7 fill-current",
  "view-box": "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
  "clip-rule": "evenodd"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-7 h-7 fill-current",
  "view-box": "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10 12a2 2 0 100-4 2 2 0 000 4z" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
  "clip-rule": "evenodd"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setViewPassword(!_ctx.viewPassword))),
        tabindex: "-1",
        type: "button",
        style: {"color":"#6e7191"},
        class: "rounded pt-7 pl-4 text-sm font-mono cursor-pointer"
      }, [
        (!_ctx.viewPassword)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
          : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
      ])
    ]),
    _createVNode(_component_Field, {
      type: _ctx.viewPassword ? 'text' : 'password',
      value: _ctx.value,
      name: _ctx.name,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update', $event.target.value))),
      placeholder: _ctx.name,
      autocomplete: "off",
      class: "border border-gray-100 focus:outline-none focus:ring-2 focus:ring-black focus:bg-white rounded-xl focus:border-gray-500 focus:shadow-sm w-full pr-8 pl-3 py-3 h-16 appearance-none"
    }, null, 8, ["type", "value", "name", "placeholder"]),
    _createElementVNode("label", {
      for: _ctx.name,
      class: "absolute top-0 left-0 px-3 py-5 h-full pointer-events-none transform origin-left transition-all text-gray-500 duration-100 ease-in-out"
    }, _toDisplayString(_ctx.label), 9, _hoisted_11),
    _createVNode(_component_ErrorMessage, {
      name: _ctx.name,
      class: "text-sm overflow-ellipsis",
      style: {"color":"#ff3333"},
      id: "error"
    }, null, 8, ["name"])
  ]))
}